import React from 'react';
import { Card, Row, Col, Badge, Button, Space, Tag } from 'antd';
import { CheckCircleOutlined, ClockCircleOutlined } from '@ant-design/icons';
import styles from './CurrentCaseTracker.module.css';

interface ICurrentCaseTrackerProps {
  caseId?: string;
  caseName?: string;
  procedures?: Array<{
    id: string;
    step: string;
    status: 'completed' | 'active' | 'pending';
    description: string;
  }>;
  onStepClick?: (stepIndex: number) => void;
}

const DEFAULT_PROCEDURES = [
  {
    id: '1',
    step: 'UPLOAD JUSTIFICATION LETTER',
    status: 'completed' as const,
    description: 'Completed',
  },
  {
    id: '2',
    step: 'QC REVIEW & SUBMIT TO PORTAL',
    status: 'active' as const,
    description: 'In progress',
  },
  {
    id: '3',
    step: 'ANNEXURE (DOWNLOAD/UPLOAD)',
    status: 'pending' as const,
    description: 'Active Step',
  },
  {
    id: '4',
    step: 'ANNEXURE REVIEW & SUBMIT TO PORTAL',
    status: 'pending' as const,
    description: 'Pending',
  },
];

const CurrentCaseTracker: React.FC<ICurrentCaseTrackerProps> = ({
  caseId = 'CASE #882-104',
  caseName,
  procedures,
  onStepClick,
}) => {
  const isClickable = (status: string) => status === 'completed' || status === 'active';
  return (
    <Card className={styles.caseTrackerCard}>
      <div className={styles.header}>
        <div>
          <Tag className={styles.activeBadge}>ACTIVE CASE</Tag>
          <h3 className={styles.caseName}>{caseName}</h3>
        </div>
        <div className={styles.caseId}>{caseId}</div>
      </div>

      <div className={styles.procedureTracker}>
        <Row gutter={[16, 16]}>
          {procedures?.map((procedure, index) => {
            const clickable = isClickable(procedure.status);
            return (
              <Col span={8} key={procedure.id}>
                <div 
                  className={`${styles.procedureStep} ${styles[procedure.status]} ${clickable ? styles.clickable : ''}`}
                  onClick={() => clickable && onStepClick?.(index)}
                  style={{display: "flex", alignItems: "center", gap: 24}}
                >
                  <div className={styles.stepIcon}>
                    {procedure.status === 'completed' && (
                      <CheckCircleOutlined style={{ fontSize: '44px', color: '#00549E' }} />
                    )}
                    {procedure.status === 'active' && (
                      <div className={styles.activeStep}>{index + 1}</div>
                    )}
                    {procedure.status === 'pending' && (
                      <div className={styles.pendingStep}>{index + 1}</div>
                    )}
                  </div>
                  <div style={{display: "flex", flexDirection: "column", gap: 8, justifyContent: "flex-start", alignItems: "flex-start"}}>
                  <p className={styles.stepLabel}>{procedure.step}</p>
                  <span className={styles.stepDescription}>{procedure.description}</span>
                  </div>
                </div>
              </Col>
            );
          })}
        </Row>
      </div>
    </Card>
  );
};

export default CurrentCaseTracker;
